import { getCurrentSessionId } from "@/impressions/session-state";

const TRUTH_SESSION_ID_HEADER = "X-Truth-Session-Id";

function getTruthSessionIdRequestHeaders(): Record<string, string> {
  const sessionId = getCurrentSessionId();

  if (!sessionId) return {};

  return { [TRUTH_SESSION_ID_HEADER]: sessionId };
}

function omitTruthSessionIdHeader(headers: unknown): void {
  if (!headers || typeof headers !== "object") return;

  const record = headers as Record<string, unknown> & {
    delete?: (name: string) => void;
  };

  if (typeof record.delete === "function") {
    record.delete(TRUTH_SESSION_ID_HEADER);
    record.delete(TRUTH_SESSION_ID_HEADER.toLowerCase());
    return;
  }

  delete record[TRUTH_SESSION_ID_HEADER];
  delete record[TRUTH_SESSION_ID_HEADER.toLowerCase()];
}

export {
  TRUTH_SESSION_ID_HEADER,
  getTruthSessionIdRequestHeaders,
  omitTruthSessionIdHeader,
};
